import { render } from "./SubscribeNewsletter.vue?vue&type=template&id=2c06aee0"
import script from "./SubscribeNewsletter.vue?vue&type=script&lang=js"
export * from "./SubscribeNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__